import React from "react";
import checked from "./../../../../../Images/checked.png";

const HowOlaplexWhy = () => {
  return (
    <div className="blogWhat-content">
      <h5>Why Choose Olaplex for Maintaining Healthy Hair After Coloring?</h5>
      <p>
        Using Olaplex products consistently can make a significant difference in
        <a href="https://scentlifestyle.com/how-olaplex-helps-maintain-healthy-hair-after-coloring">
          {" "}
          maintaining healthy hair after coloring
        </a>
        . Here are some of the reasons why Olaplex should be a staple in your
        hair care routine:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Strengthens and Repairs Hair from Within:{" "}
          </span>
          <p>
            Unlike other hair treatments that only coat the surface, Olaplex
            rebuilds broken bonds within the hair shaft, resulting in stronger,
            healthier hair.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Protects Hair During and After Coloring:{" "}
          </span>
          <p>
            By adding Olaplex No.1 to your hair color or bleach, you protect
            your hair from the damaging effects of these chemicals. Follow-up
            treatments with Olaplex No.2 further strengthen the hair after
            coloring.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Maintains Hair Color and Shine:{" "}
          </span>
          <p>
            Olaplex helps maintain the vibrancy of your color-treated hair,
            ensuring it looks fresh, shiny, and healthy for longer.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Versatile and Suitable for All Hair Types:{" "}
          </span>
          <p>
            Olaplex products are designed to work for all hair types and
            textures, making them an excellent choice for anyone looking to
            maintain hair health after coloring.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default HowOlaplexWhy;
